<template>
  <div id="app">
    <nav-bar ref="navLaber" :navType="navType" :isShowMenu="isShowMenu" :isShowSearch="isShowSearch"></nav-bar>
    <router-view />
  </div>
</template>

<script>
    import NavBar from "@/components/NavBar/index.vue"
    export default {
        components:{
            NavBar,
        },
        name: '',
        data() {
            return {
              clientHeight: '',                 //窗口高度
              navHeight:'',                     //头部高度
              routerView:null,
              navType: '',
              isShowMenu:true,                  //是否显示导航栏
              isShowSearch:true,                //是否显示搜索条
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight = `${document.documentElement.clientHeight}` 
            window.onresize = function temp() {
              this.clientHeight = `${document.documentElement.clientHeight}`;
            };

            //头部高度
            this.navHeight = this.$refs.navLaber.$el.clientHeight;
        },
        watch: {
            $route: {
                handler: 'handleGlobalRoute',
                immediate: true
            },
            clientHeight: function () {
                let difHeight = Number(this.clientHeight) - Number(this.navHeight) - 80;  //80是底部高度
                localStorage.setItem("difHeight",difHeight); 
            }
        },
        methods: {
            handleGlobalRoute(route) {
              this.handleRoute(route);
              this.setNavigationState(route);
            },
            setNavigationState(route) {
              const path = route.path;
              const query = route.query;
              let navIndex = 0;
              
              // 1. 列表页面：直接使用index参数
              if (this.isListPage(path)) {
                if (query.index !== undefined) {
                  navIndex = parseInt(query.index);
                }
              }
              // 2. 详情页面：根据各种参数推断
              else if (this.isDetailPage(path)) {
                navIndex = this.inferDetailPageNavigation(route);
              }
              // 3. 其他页面：重置为首页
              else {
                navIndex = 0;
              }
              // 设置导航状态
              if (navIndex >= 0) {
                localStorage.setItem('isCurBg', navIndex);
                // 更新导航组件状态（如果已加载）
                if (this.$refs.navLaber) {
                    this.$refs.navLaber.isCurBg = navIndex;
                }
              }
            },
            isListPage(path) {
              const listPages = [
                  '/index', '/newsIndex', '/merchantIndex', 
                  '/recruitmentIndex', '/easyBookIndex'
              ];
              return listPages.includes(path);
            },
            isDetailPage(path) {
              const detailPages = [
                  '/newsPage', '/easyBookView', '/merchantView', '/recruitmentView'
              ];
              return detailPages.includes(path);
            },

            inferDetailPageNavigation(route) {
              const query = route.query;
              let navIndex = 0;
              
              // 优先级1：直接传递的index参数
              if (query.index !== undefined) {
                return parseInt(query.index);
              }
              
              // 优先级2：根据channelId设置 - 完善普通新闻的channelId映射
              if (query.channelId) {
                const channelMap = {
                  // 热点精选相关
                  '53': 1, 
                  // 最新新闻相关
                  '15': 2, '1': 2, '2': 2, '3': 2, '4': 2, '5': 2, '6': 2,
                  '10': 2, '13': 2, '14': 2, '16': 2, '17': 2, '18': 2,
                  // 移民要闻相关
                  '8': 3,
                  // 地产头条相关
                  '9': 4,
                  // 财经资讯相关
                  '11': 5,
                  // 汽车专题相关
                  '7': 6,
                  // 奇闻趣事相关
                  '12': 7,
                  // 特殊频道
                  'd8': 8, 'd9': 9, 'd10': 10
                };
                navIndex = channelMap[query.channelId] || 2; // 默认选中最新新闻
              }
              // 优先级3：根据from参数设置
              else if (query.from) {
                const fromMap = {
                  'hot': 1, 'news': 2, 'immigration': 3, 'estate': 4,
                  'finance': 5, 'auto': 6, 'funny': 7,
                  'easybook': 10, 'merchant': 8, 'recruitment': 9
                };
                navIndex = fromMap[query.from] || 2;
              }
              // 优先级4：根据路径推断
              else {
                const pathMap = {
                  '/easyBookView': 10,
                  '/merchantView': 8,
                  '/recruitmentView': 9,
                  '/newsPage': 2 // 默认新闻详情页选中"最新新闻"
                };
                navIndex = pathMap[route.path] || 2;
              }
              return navIndex;
            },

            // inferDetailPageNavigation111(route) {
            //   const query = route.query;
            //   let navIndex = 0;
              
            //   // 优先级1：直接传递的index参数
            //   if (query.index !== undefined) {
            //     return parseInt(query.index);
            //   }
              
            //   // 优先级2：根据channelId设置
            //   if (query.channelId) {
            //     const channelMap = {
            //         '53': 1, '15': 2, '8': 3, '9': 4, '11': 5, '7': 6, '12': 7,
            //         'd8': 8, 'd9': 9, 'd10': 10
            //     };
            //     navIndex = channelMap[query.channelId] || 0;
            //   }
            //   // 优先级3：根据from参数设置
            //   else if (query.from) {
            //     const fromMap = {
            //         'hot': 1, 'news': 2, 'immigration': 3, 'estate': 4,
            //         'finance': 5, 'auto': 6, 'funny': 7,
            //         'easybook': 10, 'merchant': 8, 'recruitment': 9
            //     };
            //     navIndex = fromMap[query.from] || 0;
            //   }
            //   // 优先级4：根据路径推断
            //   else {
            //     const pathMap = {
            //         '/easyBookView': 10,
            //         '/merchantView': 8,
            //         '/recruitmentView': 9
            //     };
            //     navIndex = pathMap[route.path] || 0;
            //   }
            //   return navIndex;
            // },
            /**
             * navType设置逻辑
             */
            handleRoute(route) {
              let routes = route.path;
              if (routes == "/index") {
                  this.navType = 'home';
              } else if(routes == "/login" || routes == "/register" || routes == "/forget") {
                  this.navType = 'login';
              } else if(routes == "/recruitment" || routes == "/recruitmentAdd" || routes == "/merchant" || routes == "/merchantAdd" || routes == "/easyBook" || routes == "/easyBookAdd" ) {
                  this.navType = 'publish';
              } else if(routes == "/search") {
                  this.navType = '';
              } else {
                  this.navType = 'other';
              }
            }
        }
    }
</script>

<style>
  /* 公共样式 */
  *{
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    touch-action: pan-y;
    margin: 0;
    padding: 0;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
  a{
    text-decoration: none;
  }
  em{
    font-style: normal;
  }
  u{
      text-decoration: none;
  }
  i{
      font-style: normal;
  }
  strong{
      font-weight: normal;
  }
  h5,h6 , p{
      padding: 0;
      margin: 0;
  }
  li{
    list-style: none;
  }
  .tr{
      text-align: right;
  }
  .flexDis{
      display: flex;
  }
  .flex {
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .flex-between {
      display: flex;
      justify-content: space-between;
      align-items: center;
  }
  .align-center {
      display: flex;
      align-items: center;
  }
  .justify-content{
      justify-content: left;
  }
  .jcright{
    justify-content: right;
  }
  .flex1 {
    flex: 1;
  }
  .section {
    width: 100%;
    max-width: 1500px;  /* 最大宽度保持1500px */
    margin: auto;
    overflow: hidden;
  }
  .section2 {
    width: 100%;
    max-width: 1500px;
    margin: auto;
  }
  .bgColor {
    background-color: #90080E;
  }
  .img{
      width: 100%;
      display: block;
  }
	.pr{
		position: relative;
	}
	.banner{
		width: 1200px;
		position:absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		color: #fff;
	}
	.banner > p{
		font-size: 25px;
		margin-bottom: 20px;
	}
	.banner > span{
		font-size: 20px;
	}
  .white{
    color: #fff;
  }
  .black{
    color: #333;
  }
  .overflow{
    overflow: hidden;
  }
  .tc{
    text-align:center;
  }
  .innerBg{
    height: 170px;
    background: url('../src/assets/images/bg01.png') 100% 100% no-repeat;
		z-index: -1;
  }
  .block{
      display: block;
  }
  .pointer{
      cursor: pointer;
  }
  .fw{
    font-weight: bold;
  }
  .noData{
    width: 100%;
    min-height: 350px;
    text-align: center;
    position: relative;
  }
  .noDataBox{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .noDataBox > i{
    display: block;
    font-size: 35px;
    color: #d5d5d5;
  }
  .noDataBox > span{
    font-size: 14px;
    color: #666;
    padding-top: 5px;
    display: inline-block;
  }
  .saveChanges{
      background-color: #17b3fe;
      color: #fff;
      border-radius: 10px;
      border-color: #17b3fe;
      padding:15px 35px;
	}
	.el-pager li.active{
      background-color: #90080E !important;
      border-radius: 50% !important;
      display: inline-block !important;
      color: #fff !important;
      font-weight: normal !important;
      height: 28px !important;
      line-height: 28px !important;
      border-radius: 5px !important;
      margin: 0 5px !important;
	}
  .el-pager li , .el-pagination button, .el-pagination span:not([class*=suffix]) {
      color: #666;
  }
  .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link , .el-breadcrumb__item:last-child .el-breadcrumb__inner , .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__inner.is-link:hover {
      color: #fff !important;
  }
  .el-breadcrumb__separator{
      color: #fff;
      margin: 0 15px;
  }
  .buy-menu.el-menu.el-menu--horizontal{
      border-bottom: none;
  }
  .buy-menu.el-menu--horizontal>.el-submenu .el-submenu__title{
      color: #333 !important;
      border-bottom:none !important;
      padding: 0 10px !important;

      height: 40px !important;
      line-height: 40px !important;
  }
  .buy-box .el-badge__content.is-fixed{
      width: 18px;
      font-size: 12px;
      text-align: center;
      padding: 0;
      margin-top: 5px;
  }
  .elMenu {
      border: solid 1px #e6e6e6;
  }
  .elMenu .el-submenu__icon-arrow{
      left: 20px !important;
      right: auto;
  }
  .elMenu .el-submenu{
      background-color: #f7f7f7;
  }
  .elMenu .el-submenu .el-menu{
     padding-left: 20px;
  }
  .elMenu li.el-submenu  ul li.el-submenu {
      background-color:transparent;
  }
  .elMenu .el-submenu .el-menu-item{
      padding: 0 20px !important;
  }
  .elMenu  li ul li .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
  .breadBox .el-breadcrumb__inner a, .breadBox .el-breadcrumb__inner.is-link ,.breadBox .el-breadcrumb__item:last-child .el-breadcrumb__inner ,.breadBox .el-breadcrumb__item:last-child .el-breadcrumb__inner, .breadBox .el-breadcrumb__inner.is-link:hover {
      color: #333 !important;
  }
  .breadBox .el-breadcrumb__separator{
      color: #333;
      margin: 0 15px;
  }
  .breadBox .el-breadcrumb__inner.is-link{
      font-weight: normal;
  }
  /* 登陆 */
  .logins .el-tabs__nav-wrap::after{
    height: 0;
  }
  .logins .el-tabs__item{
      color: #999999;
      font-size: 18px;
      font-weight: bold;
  }
  .logins .el-tabs__nav-scroll{
    margin-bottom: 10px;
  }
  .logins .el-tabs__item.is-active {
      color: #444647;
  }
  .logins .el-tabs__active-bar{
    height: 4px;
    border-radius: 10px;
    background-color: #cfeffe;
  }
  .logins  .el-tabs__header{
    margin: 0;
  }
  .checkboxs .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #959595;
  }
  .login_box .el-form-item {
    margin-top: 15px;
  }
  .login_box .el-input__inner{
      background-color: #f7f7f9;
      border-radius: 0;
      border: none;
  }
  .login_box .el-form-item__label {
    padding-left: 15px;
    background-color: #f7f7f9;
    font-weight: 500;
    color: #333;
  }
  .login_box .checkboxs .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #999;
  }
  .login_box .el-checkbox__label > a{
      color: #24b7fd;
      text-decoration: underline;
  }
  .el-menu--horizontal .el-menu .el-menu-item.minMenu{
    padding: 0 20px;
  }
  .el-menu--horizontal .el-menu .el-menu-item.minMenu:hover{
    background-color: #f9f9f9;
  }
  .fl{
      float: left;
  }
  .fr{
      float: right;
  }
  .el-carousel__item{
      height: auto;
  }
  .tl{
      text-align: left !important;
  }
	.next button span{
      padding-left:  20px;
      padding-right:  20px;
	}
  .btnUpload, .btnUpload .el-upload{
      border: none !important;
  }
	.avatar-uploader .el-upload{
		  display: none;
	}
  .el-menu-vertical-demo{
      border-right: none;
  }
  .el-menu-vertical-demo .submenu__titleNews{
      background-color: #f3f3f3;
  }

  ::-webkit-scrollbar { width: 7px; height: 14px; }
  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-thumb { border-radius: 999px; border: 5px solid transparent; }
  ::-webkit-scrollbar-track { box-shadow: 1px 1px 5px rgba(0,0,0,.2) inset; }
  ::-webkit-scrollbar-thumb { min-height: 20px; background-clip: content-box; box-shadow: 0 0 0 5px rgba(0,0,0,.2) inset; }
  ::-webkit-scrollbar-corner { background: transparent; }
  
  .el-form-item__error{
      padding-left: 15px;
      padding-top: 10px;
  }
  .whiteBg{
      background-color: #fff;
  }
  .el-pagination button:disabled{
      background-color: transparent !important;
  }
  .el-tabs__item{
      font-size: 17px;
  }
  .el-tabs__active-bar {
      height: 3px;
  }
  .el-tabs__nav-wrap::after {
      background-color: #e4e7ed4a;
  }
  .el-divider {
      background-color: #dcdfe652 !important;
  }
  .dialogs .el-dialog__body {
      padding: 30px 40px;
  }
  .el-pagination .btn-next, .el-pagination .btn-prev  , .el-pager li{
      background: transparent;
  }
  .el-pagination{
      text-align: center;
      margin: 30px 0;
  }
  .el-date-editor.w100.el-input, .el-date-editor.el-input__inner{
      width: 100%;
  }
	.inteItems {
		padding: 20px 0;
		background-color: #fff;
	}
  .el-button.is-round{
      border-radius: 10px !important;
  }
  .el-pager li, .el-pagination button, .el-pagination span:not([class*=suffix]) {
      height: 28px !important;
      line-height: 28px !important;
      color: #666;
  }
  .ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .carousels .el-carousel__button {
    width: 9px;
    height: 7px;
    background-color: #d2d2d2;
    border-radius: 50px;
  }
  .carousels .el-carousel__indicator.is-active button {
    width: 30px;
    background-color: #333;
  }
  .carousels .el-carousel__indicators--horizontal {
    bottom: 25px;
    /* left: 49%; */
  }
  .yishu-img {
		display: flex;
    align-items: center;
    margin: 40px 0 20px;  
  }
  .yishu-image {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      vertical-align: bottom;
  }
  .yishu-name {
      font-size: 14px;
      margin-left: 5px;
      color: #000;
  }
  /* 修改tab */
  .custom-tabs .el-tabs__active-bar {
    background-color: #930a15 !important;
    height: 5px !important;
  }
  .custom-tabs .el-tabs__item.is-active {
    color: #333 !important;
    font-weight: bold;
  }
  .custom-tabs .el-tabs__item:hover {
    color: #333 !important;
  }
  .custom-tabs .el-tabs__item {
    height: 48px;
    line-height: 48px;
    color: #8b8b8d;
  }
  .elMenuBtn, .elMenuBtn.el-menu--horizontal>.el-submenu .el-submenu__title:hover,
  .elMenuBtn .el-menu::after, .elMenuBtn .el-menu::before, .elMenuBtn.el-menu--horizontal>.el-submenu  {
    background-color: transparent !important;
  }
  .publishWrap {
    width: 1150px;
    margin: auto;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0 !important;
  }
  /* 富文本编辑器 */
  .quill-editor-wrapper {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  /* 设置固定高度并允许滚动 */
  .quill-editor-wrapper .ql-container {
    height: 300px;
    overflow-y: auto;
  }
  .quill-editor-wrapper .ql-editor {
    min-height: 300px;
    font-size: 14px;
    line-height: 1.6;
  }
  /* 工具栏样式 */
  .quill-editor-wrapper .ql-toolbar.ql-snow {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #dcdfe6;
    padding: 8px 12px;
  }
  .quill-editor-wrapper .ql-container.ql-snow {
    border: none;
  }
  .tabsBox .el-tabs__active-bar {
    display: none;
  }
  .tabsBox .el-tabs__item.is-active {
    color: #fff;
    background-color: #90080E;
    border-radius: 20px;
    padding: 0 25px !important;

  }
  /* .tabsBox .el-tabs__item:hover {
    color: #90080E;
  } */
  /* .tabsBox .el-tabs__item.is-active {
    color: #fff;
  } */
  .tabsBox .el-tabs__item {
    min-width: 77px;
    height: 32px !important;
    line-height: 32px !important;
    font-size: 15px;
    color: #000;
    background-color: #F7F7F9;
    margin: 0 5px;
    border-radius: 16px;
  }
  .tabsBox .el-tabs__header {
    margin: 0 !important;
  }
  .el-tabs--top .el-tabs__item.is-top:last-child, .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 25px !important;
      padding-right: 25px !important;
  }
  .dropdownClick .el-dropdown {
    color: #000;
    font-size: 15px;
  }
  .dropdownClick .el-dropdown-link {
		cursor: pointer;
		color: #000;
	}
  .el-dropdown-menu__item {
    color: #000;
    font-size: 15px;
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
      background-color: #90080f0e;
      color: #90080E;
  }
  .screemTop {
    margin: 30px 0 50px 0;
  }
  .commentContents input {
    border-radius: 30px;
    background-color: #f7f7f9;
    border: none;
  }
  /* 修改样式 */
  .navSearch .el-input__inner{ 
      border-radius: 20px;
      background-color: #fff;
      border: none;
      height: 40px;
  }  
  .navSearch2 .el-input__inner{ 
      border-radius: 20px;
      /* background-color: #f7f7f9; */
      background: #F7F7F7 0% 0% no-repeat padding-box;
      border: none;
      height: 40px;
  }  
  .navSearch.navLeftSearch .el-input__inner{ 
      background-color: #ffffff;
      border: 1px solid #f7f7f7;
      height: 40px;
  }
  .searchElInputs input {
    border-radius: 40px;
    background-color:#f7f7f7;
    border: none !important;
  }
  .tabsBox .el-tabs__nav-wrap::after {
    height: 0 !important;
  }
  .comment-submit .el-button:focus, .comment-submit .el-button:hover  {
    color: #fff !important;
  }
  .list-item {
    border-bottom: 1px solid #f0f0f080;
  }
  .action-btn .el-button--primary.is-plain {
    background: transparent;
    border-color: transparent;
  }
  .area-select.el-cascader .el-input__inner::placeholder {
      color: #000 !important;
  }
  .area-select.el-cascader .el-input__inner::-webkit-input-placeholder {
      color: #000 !important;
  }
  .area-select.el-cascader .el-input__inner::-moz-placeholder {
      color: #000 !important;
  }
  .area-select.el-cascader .el-input__inner:-ms-input-placeholder {
      color: #000 !important;
  }
  .area-select .el-input__icon {
    color: #000;
  }
  .area-select.el-cascader .el-input__inner {
    text-align: left;
    border: none;
    color: #000;
    background-color: #F7F7F9;
    border-radius: 16px;
    height: 32px;
    line-height: 32px;
    max-width: 148px;
  }
  
  .el-cascader-node__label {
    font-size: 15px !important;
  }
  .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path,
  .el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover {
    color: #90080E !important;
  }
  .el-cascader-node:not(.is-disabled):hover {
      background-color: #90080f0e !important;
  }
  .news-content img {
    width: 100%;
    height: auto;
  }
  .image-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    box-sizing: border-box;
    /* background: linear-gradient(to bottom, rgba(0,0,0,0) 60%, rgba(0,0,0,0.6) 100%); */
    background: linear-gradient(180deg, #00000040 60%, rgba(0, 0, 0, .6));
  }
  .demo-ruleForm .el-input__inner::placeholder {
    color: #B8B9BD;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #0059C7 !important;
    border-color: #0059C7 !important;
  }
  .el-pager li {
    min-width: 28px !important;
    border: 1px solid #e4e4e4;
    border-radius: 3px;
    margin: 0 5px;
  }
  .el-pager li.active+li {
    border-left: 1px solid #e4e4e4 !important;
  }
  .upload-drag .el-upload {
    width: 100%;
  }
  .upload-drag .el-upload-dragger {
    width: 100%;
    background: #f7f7f9;
    border: none !important;
    overflow: auto !important;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
  }
  .upload-drag .el-upload-dragger .el-upload__text {
    height: 30px;
  }
  .reg-button.el-button--primary:focus, .el-button--primary:hover {
    background: #929292 !important;
    border-color: #929292 !important;
    color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue